import * as React from "react";
import { Grid, Container } from "@material-ui/core";
import TextEditor from "../../Editor";
import { bucketURL, showEditIconBlue } from "../../../server/constants";
import { convertToEditor } from "../../../utils/helper";
import OvalBottom from "../../OvalBottom";


function WhyKaiZen(props: any) {
  const {
    whyKaizen,
    whyKaizenDescendantText,
    valueProvided,
    valueProvidedList,
    requiredQualifications,
    requiredQualificationsList,
    kaiZenEstimator
  } = props;
  return (
    <div className="colorBg pdXsScreenTop0">
      <Container maxWidth="lg" className="pdXsScreenNone">
        <Grid container spacing={3} justifyContent="center" alignItems="center" className="colReverse colMarginNone">
          <Grid item xs={12} md={6} className="pdXsScreen20">

            <TextEditor color="primary" className="title"
                        sectionId={"whyKaizen"}
                        content={whyKaizen}
                        upperDivClass={showEditIconBlue}
            />


            <TextEditor
              className="w100 floatLeft"
              sectionId={"whyKaizenDescendantText"}
              content={whyKaizenDescendantText}
              upperDivClass={showEditIconBlue}
            />


            <TextEditor component="strong" color="primary"
                        className="w100 floatLeft mt20"
                        sectionId={"valueProvided"}
                        content={valueProvided}
                        upperDivClass={showEditIconBlue}
            />


            <TextEditor
              sectionId={"valueProvidedList"}
              content={valueProvidedList}
              upperDivClass={showEditIconBlue}/>


            <TextEditor component="strong" variant="Caption" color="primary"
                        className="w100 floatLeft mt20"
                        sectionId={"requiredQualifications"}
                        content={requiredQualifications}
                        upperDivClass={showEditIconBlue}
            />


            <TextEditor
              sectionId={"requiredQualificationsList"}
              content={requiredQualificationsList}
              upperDivClass={showEditIconBlue}
            />

          </Grid>
          <Grid item xs={12} md={6} className="pdXsScreenNone pdXsScreenBottom">
            <TextEditor content={convertToEditor("Image")}
                        src={`${bucketURL}/${kaiZenEstimator}`} sectionId={"kaiZenEstimator"}
                        className="w100 positionR h100"
                        upperDivClass={showEditIconBlue}
            />
          </Grid>
        </Grid>
      </Container>

      <OvalBottom direction="right"/>

    </div>
  )
}

export default WhyKaiZen;
